// src/screens/SignupScreen.jsx
import { useState } from "react";
import { C, globalStyles } from "../styles/tokens";
import { Icon } from "../components/UI";

export default function SignupScreen({ onLogin, onBack }) {
  const [step,    setStep]    = useState(1);
  const [loading, setLoading] = useState(false);
  const [done,    setDone]    = useState(false);
  const [form,    setForm]    = useState({
    hospName: "", regNo: "", city: "", email: "",
    phone: "", adminName: "", pass: "", confirmPass: "",
  });

  const upd = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const next = async (e) => {
    e.preventDefault();
    if (step < 2) { setStep(2); return; }
    setLoading(true);
    await new Promise((r) => setTimeout(r, 1800));
    setLoading(false);
    setDone(true);
  };

  if (done) {
    return (
      <div style={{ minHeight: "100vh", background: C.surface, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
        <style>{globalStyles}</style>
        <div className="fade-up" style={{ maxWidth: 400, width: "100%", textAlign: "center" }}>
          <div style={{ width: 80, height: 80, background: "rgba(56,142,60,.15)", border: "2px solid #388E3C", borderRadius: "50%", display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: 20 }}>
            <Icon name="check" size={40} color="#4CAF50" />
          </div>
          <h2 className="syne" style={{ fontSize: 24, color: C.text, marginBottom: 10 }}>Registration Submitted!</h2>
          <p style={{ color: C.muted, fontSize: 14, lineHeight: 1.6, marginBottom: 28 }}>
            Your hospital registration is under review. You'll receive an approval email within 24 hours.
          </p>
          <button className="btn-primary" onClick={onLogin}>Back to Sign In</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", background: C.surface, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <style>{globalStyles}</style>
      <div className="fade-up" style={{ width: "100%", maxWidth: 480 }}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={{ width: 56, height: 56, background: "rgba(198,40,40,.15)", borderRadius: 16, display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: 14 }}>
            <Icon name="hospital" size={28} color={C.red} />
          </div>
          <h1 className="syne" style={{ fontSize: 26, fontWeight: 900 }}>Register Hospital</h1>
          <p style={{ color: C.muted, fontSize: 13 }}>
            Step {step} of 2 · {step === 1 ? "Hospital Info" : "Admin Account"}
          </p>
        </div>

        {/* Step bar */}
        <div style={{ display: "flex", gap: 8, marginBottom: 24 }}>
          {[1, 2].map((s) => (
            <div key={s} style={{ flex: 1, height: 4, borderRadius: 4, background: s <= step ? C.primary : C.border, transition: "background .3s" }} />
          ))}
        </div>

        <div className="card" style={{ padding: 28 }}>
          <form onSubmit={next}>
            {step === 1 ? (
              <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                <div>
                  <label className="inp-label">Hospital Name *</label>
                  <div className="inp-wrap">
                    <span className="inp-icon"><Icon name="hospital" size={15} color={C.red} /></span>
                    <input className="inp" placeholder="City General Hospital" value={form.hospName} onChange={(e) => upd("hospName", e.target.value)} required />
                  </div>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                  <div>
                    <label className="inp-label">Registration No. *</label>
                    <div className="inp-wrap">
                      <span className="inp-icon"><Icon name="settings" size={14} color={C.red} /></span>
                      <input className="inp" placeholder="HOS/GJ/2024/001" value={form.regNo} onChange={(e) => upd("regNo", e.target.value)} required />
                    </div>
                  </div>
                  <div>
                    <label className="inp-label">City *</label>
                    <div className="inp-wrap">
                      <span className="inp-icon"><Icon name="location" size={14} color={C.red} /></span>
                      <input className="inp" placeholder="Vadodara" value={form.city} onChange={(e) => upd("city", e.target.value)} required />
                    </div>
                  </div>
                </div>
                <div>
                  <label className="inp-label">Hospital Email *</label>
                  <div className="inp-wrap">
                    <span className="inp-icon"><Icon name="mail" size={15} color={C.red} /></span>
                    <input className="inp" type="email" placeholder="info@hospital.in" value={form.email} onChange={(e) => upd("email", e.target.value)} required />
                  </div>
                </div>
                <div>
                  <label className="inp-label">Phone Number *</label>
                  <div className="inp-wrap">
                    <span className="inp-icon"><Icon name="phone" size={14} color={C.red} /></span>
                    <input className="inp" placeholder="+91 98765 43210" value={form.phone} onChange={(e) => upd("phone", e.target.value)} required />
                  </div>
                </div>
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                <div>
                  <label className="inp-label">Admin Full Name *</label>
                  <div className="inp-wrap">
                    <span className="inp-icon"><Icon name="person" size={15} color={C.red} /></span>
                    <input className="inp" placeholder="Dr. Rajesh Sharma" value={form.adminName} onChange={(e) => upd("adminName", e.target.value)} required />
                  </div>
                </div>
                <div>
                  <label className="inp-label">Password *</label>
                  <div className="inp-wrap">
                    <span className="inp-icon"><Icon name="lock" size={14} color={C.red} /></span>
                    <input className="inp" type="password" placeholder="Min 8 characters" value={form.pass} onChange={(e) => upd("pass", e.target.value)} required minLength={8} />
                  </div>
                </div>
                <div>
                  <label className="inp-label">Confirm Password *</label>
                  <div className="inp-wrap">
                    <span className="inp-icon"><Icon name="lock" size={14} color={C.red} /></span>
                    <input className="inp" type="password" placeholder="Re-enter password" value={form.confirmPass} onChange={(e) => upd("confirmPass", e.target.value)} required />
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "flex-start", gap: 10, padding: "12px 14px", background: C.card2, borderRadius: 10, border: `1px solid ${C.border}` }}>
                  <input type="checkbox" required style={{ marginTop: 2, accentColor: C.primary }} />
                  <span style={{ color: C.muted, fontSize: 12, lineHeight: 1.5 }}>
                    I agree to the <span style={{ color: C.red }}>Terms of Service</span> and <span style={{ color: C.red }}>Privacy Policy</span>
                  </span>
                </div>
              </div>
            )}

            <div style={{ display: "flex", gap: 12, marginTop: 20 }}>
              {step > 1 && (
                <button type="button" className="btn-ghost" style={{ flex: 1 }} onClick={() => setStep(1)}>← Back</button>
              )}
              <button className="btn-primary" type="submit" disabled={loading} style={{ flex: 2 }}>
                {loading
                  ? <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}><div className="spinner" /><span>Submitting...</span></div>
                  : step === 1 ? "Next →" : "Register Hospital"}
              </button>
            </div>
          </form>

          <p style={{ textAlign: "center", marginTop: 16, color: C.muted, fontSize: 13 }}>
            Already registered?{" "}
            <button onClick={onBack} style={{ background: "none", border: "none", color: C.red, fontWeight: 700, cursor: "pointer", fontSize: 13 }}>Sign In</button>
          </p>
        </div>
      </div>
    </div>
  );
}